import SduiIcon from 'src/components/miscellaneous/ui/common/SduiIcon.vue'

// New components
import SText from 'src/components/base/SText.vue'
import SHeading from 'src/components/base/SHeading.vue'
import SCard from 'src/components/base/SCard.vue'
import SLink from 'src/components/base/SLink.vue'
import SList from 'src/components/base/SList.vue'
import SListItem from 'src/components/base/SListItem.vue'
import SInput from 'src/components/base/SInput.vue'
import SSelect from 'src/components/base/SSelect.vue'
import STextarea from 'src/components/base/STextarea.vue'
import SModal from 'src/components/base/SModal/SModal.vue'
import SConfirmModal from 'src/components/base/SModal/SConfirmModal.vue'
import SDropDown from 'src/components/base/SDropDown/SDropDown.vue'

export default function registerSduiComponents(app) {
  app.component('SduiIcon', SduiIcon)
  app.component('SList', SList)

  // New components
  app.component('SText', SText)
  app.component('SHeading', SHeading)
  app.component('SCard', SCard)
  app.component('SLink', SLink)
  app.component('SListItem', SListItem)
  app.component('SInput', SInput)
  app.component('SSelect', SSelect)
  app.component('STextarea', STextarea)
  app.component('SModal', SModal)
  app.component('SConfirmModal', SConfirmModal)
  app.component('SDropDown', SDropDown)
}
